/**
 * @internal テスト時のみ参照. 通常は HlAppMode を経由すること
 * @see https://my-color.esa.io/posts/1362#User-Agent%E3%81%A7%E3%81%AE%E5%88%A4%E5%AE%9A%E6%96%B9%E6%B3%95
 */
export const userAgentIsHlApp = (userAgent: string) =>
  /hl_app\/\d+\.\d+\.\d+$/.test(userAgent.toLowerCase().trim())
